namespace('compass.hotel');

// Library / Function import
compass.requireLib('compass.util.parse');
compass.requireLib('compass.util.format');

// Sub-widget Definition
compass.hotel.SimplifiedHotelFilterDatePicker = compass.defineWidget(function SimplifiedHotelFilterDatePicker(options) {
	var me = this;
	var settings = options;
	var $j = jQuery;
	var d = $j.dom;

	// top-level methods that exist in the main Filter widget
	var mainFilter 			= settings.mainFilterWidget;
	var generateFilterKey	= mainFilter.generateFilterKey;
	var updateFilter		= mainFilter.updateFilter;
	var unsetFilter			= mainFilter.unsetFilter;
	var dispatchChange		= mainFilter.dispatchChange;

	var firstDateSearch = true;
	var formatDate = compass.util.dateFormatter('yyyy-mm-dd');
	var internalDateFormat = 'dd/mm/yyyy';
	var displayDateFormatter = compass.util.dateFormatter('dd mmm yyyy');


	// Google event tracking
	function sendGATracking() {
		if (!firstDateSearch) { // user is filtering AFTER initial search
			compass.GA.trackEvent("New Filters", "Change Check In / Check Out", "Adjust Aftter Initial Search");
		} else if (!settings.meetingInfo.entryDatesDefaultToBlank) { // initial search, dates are pre-filled
			compass.GA.trackEvent("New Filters", "Change Check In / Check Out", "Adjust When Pre-filled");
		} else if (!settings.meetingInfo.requiredCheckInOutDates) { // initial search, dates are blank, dates are not required to see hotels
			compass.GA.trackEvent("New Filters", "Change Check In / Check Out", "Adjust When Blank");
		}
	}

	/* Render the entire widget's contents */
	me.render = function(widgetElem) {
		return widgetElem.append(me.drawArriveDepart());
	};

	function getArriveInput() {
		return me.getWidgetElem().find('.arriveDateInput');
	}

	function getDepartInput() {
		return me.getWidgetElem().find('.departDateInput');
	}

	function formatDateToDigits(dateString) {
		if (!dateString || dateString.length === 0) {
			return "";
		}
		var month_abbreviation_map = {
			'Jan' : '01',
			'Feb' : '02',
			'Mar' : '03',
			'Apr' : '04',
			'May' : '05',
			'Jun' : '06',
			'Jul' : '07',
			'Aug' : '08',
			'Sep' : '09',
			'Oct' : '10',
			'Nov' : '11',
			'Dec' : '12'
		};
		var day = dateString.split(' ')[0];
		var month = dateString.split(' ')[1];
		var year = dateString.split(' ')[2];
		return day + '/' + month_abbreviation_map[month] + '/' + year;
	}

	me.setArriveDepartDates = function(arriveDate, departDate) {
		var arriveDateInput = me.getWidgetElem().find('.arriveDateInput');
		var departDateInput = me.getWidgetElem().find('.departDateInput');
		// Sets the value of the date picker & updates the input display
		arriveDateInput.datepicker('setDate', displayDateFormatter(arriveDate)); 
		departDateInput.datepicker('setDate', displayDateFormatter(departDate)); 
	};

	me.drawArriveDepart = function () {
		var minIn = compass.util.parse.ISODateParser(settings.nightsArray[0]); // ?
		var maxIn = compass.util.parse.ISODateParser(settings.nightsArray[(settings.nightsArray.length-1)]); // ?
		var minOut = compass.util.parse.ISODateParser(settings.nightsArray[0]); // ?
		var maxOut = compass.util.parse.ISODateParser(settings.nightsArray[(settings.nightsArray.length-1)]); // ?
		var defaultIn = compass.util.parse.ISODateParser(settings.meetingInfo.starts);
		var defaultOut = compass.util.parse.ISODateParser(settings.meetingInfo.ends);
		var peakNight = compass.util.parse.ISODateParser(settings.meetingInfo.peakNight);
		var keys = [generateFilterKey(), generateFilterKey()];
		var dateTimer = null;
		var arriveId = compass.generateId();
		var departId = compass.generateId();

		// Alert: both dates not entered
		me.alertBothDates = function() {
			d.alert('You must enter both a check-in AND check-out date for us to update hotels and rates.');
		};

		// Alert: check-out date is the same or prior to the check-in date
		me.alertDatesOrder = function() {
			d.alert('Check-In date must come before Check-Out date');
		};

		// Set the check-in & check-out filter values to their defaults & update the filter
		me.resetFilterToDefault = function() {
			// Set arrive and depart values for hotelInfo url params
			mainFilter.arrive = formatDate(defaultIn);
			mainFilter.depart = formatDate(defaultOut);

			// Reset the filter dates to the default dates
			updateFilter(keys[0], 'arrive', mainFilter.arrive);
			updateFilter(keys[1], 'depart', mainFilter.depart);

			dispatchChange(100);
		};

		defaultIn.setDate(defaultIn.getDate() - 1); //default start date is one day before show starts
		
		if (!settings.defaultFilterDatesToBlank) {
			// Set arrive and depart values for hotelInfo url params
			mainFilter.arrive = formatDate(defaultIn);
			mainFilter.depart = formatDate(defaultOut);

			// Set the filter dates to the default dates
			updateFilter(keys[0], 'arrive', mainFilter.arrive);
			updateFilter(keys[1], 'depart', mainFilter.depart);
		}

		// the internal date picker values are always the default dates so that the picker defaults to the default dates when you click on them
		// later on in this funciton we set the visual text to '' if the meeting rule of defaultFilterDatesToBlank is set to Y so that it looks like they are empty
		// if the rule is on, when you first get to the page, the first avail call will still not have arrive/depart dates, by design
		var arriveInput = d.input({
			className : 'arriveDateInput',
			type : 'text',
			name : 'arrive',
			'data-regexp' : '^[0-3]?[0-9]/[0-3]?[0-9]/(?:[0-9]{2})?[0-9]{2}$',
			value : displayDateFormatter(defaultIn),
			placeholder : "Choose Your Date",
			title : 'DD MMM YYYY',
			id : arriveId
		});

		var departInput = d.input({
			className: 'departDateInput',
			type : 'text',
			name : 'depart',
			'data-regexp' : '^[0-3]?[0-9]/[0-3]?[0-9]/(?:[0-9]{2})?[0-9]{2}$', 
			value : displayDateFormatter(defaultOut),
			placeholder : "Choose Your Date",
			title : 'DD MMM YYYY',
			id : departId
		});

		var arriveInputWrapper = d.div(
			{className : 'datePicker roundedContainer arriveDateInputWrapper'},
			d.div(
				{className : 'dateInputLabel'},
				'Check In <i class="calendarIcon fa-regular fa-calendar-day"></i>'
			),
			arriveInput
		);

		var departInputWrapper = d.div(
			{className : 'datePicker roundedContainer departDateInputWrapper'},
			d.div(
				{className : 'dateInputLabel'},
				'Check Out <i class="calendarIcon fa-regular fa-calendar-day"></i>'
			),
			departInput
		);

		// `beforeShow` function to customize the functionality / display of the jQuery UI datepicker widget
		var datepickerSetup = function(input, inst) {
			var datepickerDiv = inst.dpDiv[0];
			var inputField = input;
			// Use Timeout for force customization to run AFTER element has generated & rendered
			setTimeout(function() {
				if (inputField.value !== "") {
					// Create the 'Clear' button element. Removes the selected date & hides the datepicker.
					var clearButton = d.div(
						{className: 'dateClearButton'},
						d.span('Clear')
					);
					clearButton.click(function(evt) {
						$(input).val('');
						$(input).datepicker("hide");
						$(input).change(); // need to trigger the onChange update functionality
						compass.GA.trackEvent("New filters", "Change Check In / Check Out", "Clear Dates");
					});
					$(datepickerDiv).append(clearButton);
				}
				$('.ui-datepicker a.ui-state-default').first().focus(); // focus the first selectable date in the datepicker
			}, 1);
		};

		function startDatePickerBothDatesTimer() {
			if ((getArriveInput().val().length === 0 && getDepartInput().val().length > 0) || (getArriveInput().val().length > 0 && getDepartInput().val().length === 0)) {
				if(dateTimer != null) {
					window.clearTimeout(dateTimer);
				}
				dateTimer = window.setTimeout(me.alertBothDates, 15000);
			}
		}

		$(arriveInput).datepicker({
			dateFormat : 'dd M yy',
			showAnim : "",
			minDate : minIn,
			maxDate : maxIn,
			defaultDate : peakNight,
			beforeShow: datepickerSetup,
			onClose: startDatePickerBothDatesTimer
		});

		$(departInput).datepicker({
			dateFormat : 'dd M yy',
			showAnim : "",
			minDate : minOut,
			maxDate : maxOut,
			defaultDate : peakNight,
			beforeShow: datepickerSetup,
			onClose: startDatePickerBothDatesTimer
		});

		$('.ui-datepicker').addClass('notranslate simplified-filter');
		$('.ui-datepicker').on('keyup', function(evt) {
			if (evt.keyCode === 27) {
				$(lastDateInputSelected).datepicker('hide');
				if (lastDateInputSelected === arriveInput) {
					$(departInput).focus();
				} else if (lastDateInputSelected === departInput) {
					$('.hotelChainFilterDropdown .dataSelectInput').focus();
				}
			}
		});

		// 'On Click' events
		arriveInput.click(function(evt) {
			if (!arriveInput.datepicker("widget").is(":visible")) {
				arriveInput.datepicker("show");
			}
		});

		departInput.click(function(evt) {
			if (!departInput.datepicker("widget").is(":visible")) {
				departInput.datepicker("show");
			}
		});

		// 'On Key Release' events
		arriveInput.keyup(function(evt) {
			getArriveInput().parsley().validate();
			if (getArriveInput().val().length === 0 && getDepartInput().val().length === 0) {
				me.resetFilterToDefault();
			} else if ((getArriveInput().val().length > 0 && getDepartInput().val().length > 0) && dateTimer != null) {
				window.clearTimeout(dateTimer);
			}
		});

		departInput.keyup(function(evt) {
			getDepartInput().parsley().validate();

			if (getArriveInput().val().length === 0 && getDepartInput().val().length === 0) {
				me.resetFilterToDefault();
			} else if ((getArriveInput().val().length > 0 && getDepartInput().val().length > 0) && dateTimer != null) {
				window.clearTimeout(dateTimer);
			}
		});

		// 'On Focus' events
		let lastDateInputSelected;
		arriveInput.focus(function(evt) {
			lastDateInputSelected = arriveInput;
			if(getArriveInput().val().length === 0 && dateTimer != null){
				window.clearTimeout(dateTimer);
			}
		});

		departInput.focus(function(evt) {
			lastDateInputSelected = departInput;
			if (getDepartInput().val().length === 0 && dateTimer != null) {
				window.clearTimeout(dateTimer);
			}
		});

		// 'On Blur' events
		arriveInput.blur(function(evt) {
			getArriveInput().parsley().validate();
			if (getArriveInput().parsley().isValid() !== true && getArriveInput().val().length > 0) {
				getArriveInput().focus();
			}
		});

		departInput.blur(function(evt) {
			getArriveInput().parsley().validate();
			if (getDepartInput().parsley().isValid() !== true && getDepartInput().val().length > 0) {
				getDepartInput().focus();
			}
		});

		// 'On Change' events
		arriveInput.change(function(evt) {
			getArriveInput().parsley().validate();
			if (dateTimer != null) {
				window.clearTimeout(dateTimer);
			}
			var arrive = formatDateToDigits(getArriveInput().val());
			var depart = formatDateToDigits(getDepartInput().val());
			let focusDepart = false;
			if (arrive.length > 0 && depart.length > 0) {
				if (getArriveInput().parsley().isValid() && getDepartInput().parsley().isValid()) {
					arrive = compass.util.parse.DateParse(arrive, internalDateFormat);
					mainFilter.arrive = formatDate(arrive);
					depart = compass.util.parse.DateParse(depart, internalDateFormat);
					mainFilter.depart = formatDate(depart);
					if (depart.valueOf() - arrive.valueOf() > 0) {
						updateFilter(keys[0], 'arrive', mainFilter.arrive);
						updateFilter(keys[1], 'depart', mainFilter.depart);
						dispatchChange(100);
						focusDepart = true;
						sendGATracking();
						firstDateSearch = false;
						mainFilter.updateFilterLock(false);
					} else {
						me.alertDatesOrder();
					}
				}
			} else if ((getArriveInput().val().length === 0 && getDepartInput().val().length > 0) || (getArriveInput().val().length > 0 && getDepartInput().val().length === 0)) {
				if(dateTimer != null) {
					window.clearTimeout(dateTimer);
				}
				dateTimer = window.setTimeout(me.alertBothDates, 15000);
				focusDepart = true;
			} else if (arrive.length === 0 && depart.length === 0) {
				me.resetFilterToDefault();
				focusDepart = true;
			}

			if (focusDepart) {
				window.setTimeout(function() {
					getDepartInput().focus();
				}, 100);
			}
		});

		departInput.change(function(evt) {
			getDepartInput().parsley().validate();
			if (dateTimer != null) {
				window.clearTimeout(dateTimer);
			}
			var arrive = formatDateToDigits(getArriveInput().val());
			var depart = formatDateToDigits(getDepartInput().val());
			let nextFocus;
			if (arrive.length > 0 && depart.length > 0) {
				if(getArriveInput().parsley().isValid() && getDepartInput().parsley().isValid()){
					arrive = compass.util.parse.DateParse(arrive, internalDateFormat);
					mainFilter.arrive = formatDate(arrive);
					depart = compass.util.parse.DateParse(depart, internalDateFormat);
					mainFilter.depart = formatDate(depart);
					if (depart.valueOf() - arrive.valueOf() > 0) {
						updateFilter(keys[0], 'arrive', mainFilter.arrive);
						updateFilter(keys[1], 'depart', mainFilter.depart);
						dispatchChange(100);
						sendGATracking();
						firstDateSearch = false;
						mainFilter.updateFilterLock(false);
						nextFocus = $('.hotelChainFilterDropdown .dataSelectInput');
					} else {
						me.alertDatesOrder();
					}
				}
			} else if ((getArriveInput().val().length === 0 && getDepartInput().val().length > 0) || (getArriveInput().val().length > 0 && getDepartInput().val().length === 0)) {
				if (dateTimer != null) {
					window.clearTimeout(dateTimer);
				}
				if (getArriveInput().val().length === 0) nextFocus = getArriveInput();
				dateTimer = window.setTimeout(me.alertBothDates, 15000);
			} else if (arrive.length === 0 && depart.length === 0){
				me.resetFilterToDefault();
				nextFocus = $('.hotelChainFilterDropdown .dataSelectInput');
			}

			if (nextFocus) {
				window.setTimeout(function() {
					nextFocus.focus();
				}, 100);
			}
		});

		// Make date inputs appear blank. Their internal values should be the default dates, NOT today's date
		if (settings.defaultFilterDatesToBlank) {
			arriveInput.val('');
			departInput.val('');
		}
		
		return [
			arriveInputWrapper,
			departInputWrapper,
			d.div({className : 'clear'})
		];
	};

}, {
	WUID : 'SimplifiedHotelFilterDatePicker',
	widgetName : 'SimplifiedHotelFilterDatePicker',
	mainFilterWidget : {},
	meetingInfo : {"minCheckIn" : "04/27/2012", "maxCheckIn" : "05/03/2012", "minCheckOut" : "04/28/2012",  "maxCheckOut" : "05/04/2012",  "starts": "04/29/2012", "ends": "05/01/2012" },
	dateFormat : 'MM/DD/YYYY',
	defaultFilterDatesToBlank : false,
	nightsArray : [],
	filterChangeDelay : 200
});
